import React from 'react';
import BusinessFinancialReportPage from './BusinessFinancialReportPage';

export default function ReportWeeklyPage(props) {
  return <BusinessFinancialReportPage {...props} initialPeriod="week" />;
}
